export const ErrorCodes = {
  NoSupplierId: 'NoSupplierId',
} as const;
